// import Auth from './src/auth'
// import Cookies from './src/cookies'
import Format from './src/format'
import Math from './src/math'

export default {
  name: 'NZUtils',
  // Auth,
  // Cookies,
  Format,
  Math
}
